<template>
  <div class="contenedor">
      <table border="0" style="width:100%;border-collapse:collapse;margin:auto;" class="table table-condensed">
        <tr>
          <th width="100%" id="pel-fisico">
            Indicaciones de peligro
          </th>
        </tr>
        <tr>
          <td style="font-size:12px;">
            <el-select class="inp_form sel_multiple2grande sel_let_peq" multiple v-model="selectedSga">
              <el-option v-for="frase in frasesHSga" :key="frase.codigo" :value="frase.codigo" :label="frase.codigo+' - '+frase.descripcion"></el-option>
            </el-select>
          </td>
        </tr>
      </table>
      <br>
      <b-row class="d-flex justify-content-center" v-if="dataPadre.producto">
        <b-button variant="primary" @click="guardaSga"><i class="fa fa-save"></i> Guardar</b-button>
      </b-row>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';

export default {
  name: 'SgaFrases',
  data() {
      return {
          selectedSga: []
      }
  },
  props: ['dataPadre'],
  computed: {
    disabledInputs() {
      return this.selectedProductEt.finalizado == 0 ? false : true
    },
    ...mapState('', [
      ''
    ]),
    ...mapState('', [
      ''
    ])
  },
  watch: {
      selectedSga(newValue) {
        let data = this.dataPadre;
        data.values = newValue;
        this.$emit('guardarFrases', data);
      }
  },
  methods: {
    obtenerFrasesH(e) {
        
    },
    async guardaSga() {
      this.load(true);
      /* await this.guardarSga();
      await this.getFrases(); */
      this.load(false);
    },
    ...mapActions('', [
      ''
    ]),
    ...mapMutations('dashboard', [
      'load'
    ]),
  },
  computed: {
    ...mapState('sga', [
        'frasesHSga'
    ])
  }
}
</script>
<style scoped>
#pel-fisico {
  text-align: center;
  background: #00645a;
  color: white;
}

#pel-salud {
  text-align: center;
  background: #1f487b;
  color: white;
}

#pel-ambiente {
  text-align: center;
  background: #36b564;
  color: white;
}

#sus-peligrosas {
  text-align: center;
  background: #55b543;
  color: white;
}
</style>
